export default class SlingApi {
  constructor(HttpLayer, sdk) {
    'ngInject';

    const SlingApiSdk = sdk('SlingApi');
    return new SlingApiSdk(HttpLayer);
  }
}
